import { IInventoryItemsQueryParamsForPurchaseOrCreditPurchase } from 'gen/ApiClient';

export const DefaultInventoryItemsQueryParamsForPurchaseOrCreditPurchase: IInventoryItemsQueryParamsForPurchaseOrCreditPurchase = {
	searchString: '',
	sortParams: { direction: 'desc', property: 'created' },
	pageParams: { index: 1, size: 10 },
	categories: [],
	subcategories: [],
	forProductCatalogId: undefined,
	isShowAll: false,
	supplierId: undefined,
};
